// Ranges and defaults from Vapi's FourierDenoisingPlan
export const FOURIER_DENOISING_NUMBER_SETTINGS = {
    staticThreshold: { label: 'Static threshold (dB)', min: -80, max: 0, step: 1, defaultValue: -35 },
    baselineOffsetDb: { label: 'Baseline offset (dB)', min: -30, max: -5, step: 1, defaultValue: -15 },
    windowSizeMs: { label: 'Window size (ms)', min: 1000, max: 30000, step: 100, defaultValue: 3000 },
    baselinePercentile: { label: 'Baseline percentile', min: 1, max: 99, step: 1, defaultValue: 85 }
};
export const FOURIER_DENOISING_NUMBER_SETTING_NAMES = Object.keys(FOURIER_DENOISING_NUMBER_SETTINGS);
//# sourceMappingURL=vapi-fourier-denoising.js.map